import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

export default function ErrorState({ message, onRetry, className = '' }) {
  return (
    <div className={`bg-red-50 border border-red-200 rounded-lg p-4 ${className}`}>
      <div className="flex items-start gap-2">
        <AlertTriangle size={16} className="text-red-600 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <div className="text-sm font-semibold text-red-800 mb-0.5">Não foi possível carregar</div>
          <div className="text-xs text-red-700 break-words">{message || 'Erro desconhecido.'}</div>
        </div>
        {onRetry && (
          <button
            onClick={onRetry}
            className="text-xs px-2 py-1 bg-white text-red-700 border border-red-300 rounded hover:bg-red-100 flex items-center gap-1"
          >
            <RefreshCw size={12} /> Tentar novamente
          </button>
        )}
      </div>
    </div>
  );
}
